import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

function ModuleActivityChart({
    data
}) {
    const dataSample = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 },
        { name: 'Group C', value: 300 },
        { name: 'Group D', value: 200 }
    ];

    return (
        <ResponsiveContainer width={'100%'} height={200}>
            <PieChart>
                <Pie
                    dataKey="value"
                    data={data}
                    startAngle={-270}
                    cx="50%"
                    cy="50%"
                    outerRadius={50}
                    innerRadius={30}
                    label={(entry) => entry.value && ` ${entry.name} ${(entry.percent * 100).toFixed(0)}% `}
                    labelLine={false}
                    fill="red"
                    stroke="#000000"
                    strokeOpacity={0.2}
                    strokeWidth={5}

                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} fontSize={14} />
                    ))}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    )
}

export default ModuleActivityChart